import PushNotifications from "../symbols/pushNotifications";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function PushNotificationsReducer(state = initialState, action: any) {
  switch (action.type) {
    case PushNotifications.PUSH_NOTIFICATIONS:
      return { ...state, loading: true, error: false };
    case PushNotifications.PUSH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case PushNotifications.PUSH_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case PushNotifications.CLEAR_PUSH_NOTIFICATIONS:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
